var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pulse w-30 h-8 mb-4 rounded-lg"}),_c('div',{staticClass:"flex overflow-x-scroll w-full slider"},[_vm._t("item")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }